import { useAuth } from '@/composables/models/useAuth';
import { useMockedAuth } from '@/composables/utils/useMockAuth';
// ログインしていなくても入れる画面のリスト
const URL_LIST = ['/signin'];

export default defineNuxtRouteMiddleware(async (to) => {
  const runtimeConfig = useRuntimeConfig();
  const injectedUseAuth = runtimeConfig.public.PLAYWRIGHT_TEST === 'true' ? useMockedAuth : useAuth;
  const { getToken } = injectedUseAuth();

  // 未ログイン、かつ、ログイン済みでないと開けない画面の場合はログインページへリダイレクトする
  if (!(await getToken()) && !URL_LIST.includes(to.fullPath)) {
    return navigateTo('/signin');
  }
});
